
import focusMixin from '@/features/common/mixins/focusMixin';
import {
  Component, PropSync, Mixins,
} from 'vue-property-decorator';

@Component
export default class NoPickupModal extends Mixins(focusMixin) {
  @PropSync('show', { required: true }) syncedShow!: boolean;

  private isLoading = false;

  private continueNoPickupRequired() {
    this.isLoading = true;
    this.$emit('noSchedulePickup');

    setTimeout(() => {
      this.isLoading = false;
    }, 3000);
  }
}
